import { Tooltip } from "@mui/material";
import React, { useState } from "react";
import { FaSortUp, FaSortDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import AddAccount from "./AddAccount";
import { ReactComponent as Dropdown } from "../../assets/images/dropdowniconcoatable.svg";
import { ReactComponent as EditIcon } from "../../assets/images/editIconCoaTable.svg";
import { ReactComponent as ProhibitIcon } from "../../assets/images/prohibitIconCoaTable.svg";
import { ReactComponent as Delete } from "../../assets/images/deleteIconCoaTable.svg";
import { ReactComponent as ThreeDotsVertical } from "../../assets/images/threeDotVertical.svg";
import { ReactComponent as Line } from "../../assets/images/line.svg";

const ChartOfAccountTable = ({ data, setData, openPopup, formData, setFormData, isEditMode, setIsEditMode }) => {
  const accountTypes = ["Standard", "Premium", "Enterprise"];
  const headers = [
    { key: "account_code", label: "Code" },
    { key: "account_name", label: "Name" },
    { key: "accountType", label: "Account Type" },
    { key: "detailType", label: "Detail Type" },
    { key: "balance", label: "Balance" },
    { key: "actions", label: "Actions" },
  ];

  const [updateData, setUpdateData] = useState({
    account_name: "",
    description: "",
  });
  //   const [data, setData] = useState([
  //     {
  //       id: 1,
  //       name: 'Parent Item 1',
  //       age: 50,
  //       accountType: "Standard",
  //       children: [
  //         {
  //           id: 2,
  //           name: 'Child Item 1.1',
  //           age: 25,
  //           accountType: "Premium",
  //           children: [
  //             {
  //               id: 3,
  //               name: 'Grandchild Item 1.1.1',
  //               age: 5,
  //               accountType: "Enterprise",
  //               children: [
  //                 {
  //                   id: 4,
  //                   name: 'Great-Grandchild Item 1.1.1.1',
  //                   age: 1,
  //                   accountType: "Standard",
  //                 },
  //               ],
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     // Additional parent and child data here
  //   ]);

  const [sortConfig, setSortConfig] = useState({ key: "name", direction: "asc" });
  const [selectedRows, setSelectedRows] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({
    select: true,
    account_code: true,
    account_name: true,
    accountType: true,
    detailType: true,
    balance: true,
    actions: true,
  });
  const [editingRow, setEditingRow] = useState(null);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});

  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id) ? prevSelected.filter((rowId) => rowId !== id) : [...prevSelected, id]
    );
  };
  const handleDropdownClick = (accountName) => {
    setSelectedItems((prevState) => {
      if (prevState[accountName]) {
        const updatedState = { ...prevState };
        delete updatedState[accountName];
        return updatedState;
      } else {
        return { ...prevState, [accountName]: true };
      }
    });
  };

  const toggleColumnVisibility = (column) => {
    setColumnVisibility((prevVisibility) => ({
      ...prevVisibility,
      [column]: !prevVisibility[column],
    }));
  };

  const handleEditRow = (id) => {
    setEditingRow(id);
  };
  const handleEditEntry = (item) => {
    openPopup();
    setIsEditMode(item.account_code);
    setFormData((prevState) => ({
      ...prevState,
      account_name: item.account_name,
      descriptions: item.description,
    }));
  };

  const handleSaveRow = (id, updatedRow) => {
    setData((prevData) => prevData.map((row) => (row.id === id ? { ...row, ...updatedRow } : row)));
    setEditingRow(null);
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const renderRow = (item, level = 0) => (
    <React.Fragment key={item.id}>
      <tr className={`${level === 0 ? "bg-gray-200" : "bg-gray-50"}`}>
        {/* {columnVisibility.select && (
          <td className="px-4 py-[2px] border border-gray-300">
            <input
              type="checkbox"
              checked={selectedRows.includes(item.id)}
              onChange={() => handleCheckboxChange(item.id)}
            />f
          </td>
        )} */}

        {headers.map((header) => (
          <td className={`pr-4 py-[2px] border-y border-gray-300 `}>
            <div className="flex items-center gap-2">
              {header.key !== "actions" && (
                <>
                  <p
                    style={{
                      paddingLeft: header.key === "account_code" ? `${(level + 1) * 10}px` : undefined,
                    }}
                    className={`${header.key == "account_code" ? `text-[#2999bc] ` : "text-[#383838] text-xs"} text-xs `}
                  >
                    {item[header.key]}
                  </p>
                  {header.key == "account_code" && level == 0 && (
                    <button onClick={() => handleDropdownClick(item.account_name)} className="cursor-pointer px-2">
                      <Dropdown />
                    </button>
                  )}
                </>
              )}
              {header.key == "actions" && (
                <button onClick={() => handleEditEntry(item)} className="cursor-pointer">
                  <EditIcon />
                </button>
              )}
            </div>
          </td>
        ))}
      </tr>
      {(level !== 0 || selectedItems[item.account_name]) &&
        item.children &&
        item.children.map((child) => renderRow(child, level + 1))}
    </React.Fragment>
  );

  return (
    <div>
      {/* Sidebar for Column Visibility */}

      {/* Table */}
      <div className="overflow-x-auto p-4 pt-0">
        <div className="flex justify-end">
          <div>
            <button onClick={openPopup} className="text-center text-288FB2 text-xl" type="button">
              +
            </button>

            <button onClick={handleDropdownToggle} className="ms-2">
              <i class="bi bi-sliders2 text-xl"></i>
            </button>

            {isDropdownOpen && (
              <div className="absolute right-[32px] bg-white p-3">
                <label className="flex items-center mb-2">
                  <input
                    type="checkbox"
                    checked={columnVisibility.select}
                    onChange={() => toggleColumnVisibility("select")}
                    className="mr-2"
                  />
                  Select
                </label>
                <label className="flex items-center mb-2">
                  <input
                    type="checkbox"
                    checked={columnVisibility.code}
                    onChange={() => toggleColumnVisibility("code")}
                    className="mr-2"
                  />
                  Code
                </label>
                <label className="flex items-center mb-2">
                  <input
                    type="checkbox"
                    checked={columnVisibility.name}
                    onChange={() => toggleColumnVisibility("name")}
                    className="mr-2"
                  />
                  Name
                </label>
                <label className="flex items-center mb-2">
                  <input
                    type="checkbox"
                    checked={columnVisibility.accountType}
                    onChange={() => toggleColumnVisibility("accountType")}
                    className="mr-2"
                  />
                  Account Type
                </label>

                <label className="flex items-center mb-2">
                  <input
                    type="checkbox"
                    checked={columnVisibility.detailType}
                    onChange={() => toggleColumnVisibility("detailType")}
                    className="mr-2"
                  />
                  Detail Type
                </label>
                <label className="flex items-center mb-2">
                  <input
                    type="checkbox"
                    checked={columnVisibility.balance}
                    onChange={() => toggleColumnVisibility("balance")}
                    className="mr-2"
                  />
                  Balance
                </label>
              </div>
            )}
          </div>
        </div>

        <table className="min-w-full text-sm bg-white  table-fixed">
          <thead className="text-1D4469 text-xs">
            <tr className="border-b border-E1E6EC  font-normal">
              {/* {columnVisibility.select && (
                <th className="px-4 py-2 h-[47px]  ">
                  <div className="flex justify-between items-center">
                    <div className="text-[#1D4469] font-poppins text-xs font-500">Select</div>
                    <div>
                    <ThreeDotsVertical />
                    
                    </div>
                    
                  </div>
                </th>
              )} */}
              {/* {columnVisibility.code && (
                <th className="px-4 py-2 ">
                  <button onClick={() => handleSort("code")} className="flex items-center gap-1">
                    Code
                    {sortConfig.key === "code" ? (
                      sortConfig.direction === "asc" ? (
                        <FaSortUp />
                      ) : (
                        <FaSortDown />
                      )
                    ) : (
                      <FaSortUp className="opacity-50" />
                    )}
                  </button>
                </th>
              )}
              {columnVisibility.name && (
                <th className="px-4 py-2 ">
                  <button onClick={() => handleSort("name")} className="flex items-center gap-1">
                    Name
                    {sortConfig.key === "name" ? (
                      sortConfig.direction === "asc" ? (
                        <FaSortUp />
                      ) : (
                        <FaSortDown />
                      )
                    ) : (
                      <FaSortUp className="opacity-50" />
                    )}
                  </button>
                </th>
              )}
              {columnVisibility.accountType && <th className="px-4 py-2 ">Account Type</th>}

              {columnVisibility.detailType && (
                <th className="px-4 py-2 ">
                  <button onClick={() => handleSort("detailType")} className="flex items-center gap-1">
                    Detail Type
                    {sortConfig.key === "detailType" ? (
                      sortConfig.direction === "asc" ? (
                        <FaSortUp />
                      ) : (
                        <FaSortDown />
                      )
                    ) : (
                      <FaSortUp className="opacity-50" />
                    )}
                  </button>
                </th>
              )}

              {columnVisibility.balance && (
                <th className="px-4 py-2 ">
                  <button onClick={() => handleSort("balance")} className="flex items-center gap-1">
                    Balance
                    {sortConfig.key === "balance" ? (
                      sortConfig.direction === "asc" ? (
                        <FaSortUp />
                      ) : (
                        <FaSortDown />
                      )
                    ) : (
                      <FaSortUp className="opacity-50" />
                    )}
                  </button>
                </th>
              )} */}

              {headers?.map(
                (header) =>
                  columnVisibility[header.key] && (
                    <th className="px-4 py-1 h-[45px] ">
                      <div className="flex items-center justify-between">
                        <button onClick={() => handleSort(header.key)} className="flex items-center gap-1">
                          <p className="text-[#1D4469] font-poppins text-xs font-500">{header.label}</p>

                          {/* {sortConfig.key === "code" ? (
    sortConfig.direction === "asc" ? (
      <FaSortUp />
    ) : (
      <FaSortDown />
    )
  ) : (
    <FaSortUp className="opacity-50" />
  )} */}
                        </button>
                        <div class="flex items-center gap-2">
                          <ThreeDotsVertical />
                          <Line className="h-[30px]" />
                        </div>
                      </div>
                    </th>
                  )
              )}

              {/* <th className="px-4 py-2 ">Actions</th> */}
            </tr>
          </thead>
          <tbody>{data?.map((item) => renderRow(item))}</tbody>
        </table>
      </div>
    </div>
  );
};

export default ChartOfAccountTable;
